
import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css'; 

const TransactionHistory = () => {
  const [transactions, setTransactions] = useState([]);
  const [filteredTransactions, setFilteredTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    
    fetch('https://api.bigfresh.in/fetch-tranx')
      .then((response) => response.json())
      .then((data) => {
       
        if (data && Array.isArray(data.tranxData)) {
          setTransactions(data.tranxData); 
          setFilteredTransactions(data.tranxData);
          console.log(data.tranxData);
        } else {
          console.error('Unexpected data format:', data);
          setTransactions([]);
          setFilteredTransactions([]); 
        }
        setLoading(false); 
      })
      .catch((error) => {
        setError(error);
        setLoading(false); 
      });
  }, []);

  useEffect(() => {
    
    if (searchQuery) {
      const filtered = transactions.filter((transaction) =>
        transaction.trans_type.toLowerCase().includes(searchQuery.toLowerCase())
      );
      setFilteredTransactions(filtered);
    } else {
      setFilteredTransactions(transactions); 
    }
  }, [searchQuery, transactions]);

  if (loading) {
    return <div className="text-center">Loading...</div>;
  }

  if (error) {
    return <div className="text-danger">Error fetching data: {error.message}</div>;
  }

  return (
    <div className="container mt-5">
      <h2 className="mb-4 fw-bold text-success text-center">Transaction History</h2>
      
      {/* Search bar */}
      <div className="mb-4">
        <input
          type="text"
          className="form-control"
          placeholder="Search by Transaction Type "
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>
      
      {filteredTransactions.length === 0 ? (
        <p>No transactions found.</p>
      ) : (
        <table className="table table-bordered table-striped table-hover">
          <thead>
            <tr>
              <th>ID</th>
              <th>Amount</th>
              <th>Date</th>
              <th>Status</th>
              <th>User ID</th>
              <th>Transaction Type</th>
              <th>Name</th>
            </tr>
          </thead>
          <tbody>
            {filteredTransactions.map((transaction) => (
              <tr key={transaction.id}>
                <td>{transaction.id}</td>
                <td>{transaction.amount}</td>
                <td>{transaction.pay_date}</td>
                <td>{transaction.is_verify}</td>
                <td>{transaction.user_id}</td>
                <td>{transaction.trans_type}</td>
                <td>{transaction.name}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default TransactionHistory;

